// extracted by mini-css-extract-plugin
export default {"container":"VerificationError_container__jJyIC"};